const Icon = (props) => {
  return (
    <i
      className={`${props.name} ${props.className}`}
      style={{ fontSize: props.size, ...props.style }}
    />
  );
};

export default Icon;
